import { all } from 'redux-saga/effects';

import eventSagas from './event';

export default function* rootSaga() {
  yield all([eventSagas()]);
}
